import { NAV_ITEM_HOME } from '@/path';
import { Stack, Theme, useMediaQuery, useTheme } from '@mui/material';
import { clarityTokens } from '@verifime/design-tokens';
import { useRouter } from 'next/router';
import ClarityLogo from './ClarityLogo';

/**
 * ClarityLogoBg component displays the Clarity logo with a purple background.
 * This is a reusable component for navigation headers in the customer-portal.
 * Used in ClarityPageShell and Wizard forms.
 */
export default function ClarityLogoBg() {
  const theme = useTheme();
  const router = useRouter();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      sx={(theme: Theme) => ({
        // UX requested permanent purple background for the logo area
        // TODO: We should migrate to using semantic tokens for this in the future instead of hardcoding clarity token colors, but for now this is a quick way to get the new logo in with the correct background for the portal release.
        backgroundColor: clarityTokens.colorEggplant500,
        padding: `${theme.semantic.spacing.xs} ${theme.semantic.spacing.base}`,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      })}
      onClick={() => router.push(NAV_ITEM_HOME.path)}
    >
      <ClarityLogo layout={isMobile ? 'markOnly' : 'horizontal'} colorMode="onPrimary" />
    </Stack>
  );
}
